module.exports = __webpack_public_path__ + "static/media/064-punk.881c40e0.svg";